import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrganizationPickerComponent } from './components/organization-picker/organization-picker.component';
import { NgxsModule } from '@ngxs/store';
import { OrganizationsState } from './state/organizations.state';
import { MaterialModule } from '../material.module';
import { SharedModule } from '../shared/shared.module';
import { CollectionPickerComponent } from './components/collection-picker/collection-picker.component';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule,
    NgxsModule.forFeature([
      OrganizationsState
    ])
  ],
  declarations: [
    OrganizationPickerComponent,
    CollectionPickerComponent
  ],
  exports: [
    OrganizationPickerComponent,
    CollectionPickerComponent
  ]
})
export class OrganizationsModule { }
